var React = require('react');

function IconFlash (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.75539 14.0046H4.002C3.1111 14.0046 2.66493 12.9275 3.2949 12.2975L14.2949 1.29751C15.0121 0.580348 16.2181 1.26321 15.9721 2.24715L14.2828 9.00462H19.002C19.8721 9.00462 20.3271 10.0389 19.7392 10.6803L8.73916 22.6803C8.04771 23.4347 6.80384 22.7866 7.02582 21.7877L8.75539 14.0046ZM13.1562 5.26461L6.41622 12.0046H10.002C10.6418 12.0046 11.117 12.597 10.9782 13.2215L9.78831 18.576L16.7288 11.0046H13.002C12.3514 11.0046 11.8741 10.3932 12.0319 9.76208L13.1562 5.26461Z"}));
}

IconFlash.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconFlash;

IconFlash.default = IconFlash;
